export function getChartDurationTypeFormat(start, end) {
  let add_unit = 'year', format = 'YYYY'
  if (end.diff(start, 'years') >= 1) {
    add_unit = 'year';
    format = 'YYYY';
  } else if (end.diff(start, 'months') >= 1) {
    add_unit = 'month';
    format = 'MMM';
  } else if (end.diff(start, 'weeks') >= 1) {
    add_unit = 'day';
    format = 'MMM DD';
  } else if (end.diff(start, 'days') > 1) {
    add_unit = 'day';
    format = 'dddd';
  } else if (end.diff(start, 'hours') > 1) {
    add_unit = 'hour';
    format = 'hh:00 A';
  } else if (end.diff(start, 'minutes') > 1) {
    add_unit = 'minute';
    format = 'hh:mm A';
  } else if (end.diff(start, 'seconds') >= 1) {
    add_unit = 'second';
    format = 'hh:mm:ss A';
  } else if (end.diff(start, 'milliseconds') >= 1) {
    add_unit = 'milliseconds';
    format = 'ms';
  }
  return {
    unit: add_unit,
    format: format,
  }
}